import * as envsetting from '../../config/envsetting'
import axios from 'axios'
import * as common from './common'

const chargeUrl = envsetting.chargeServeUrl

export const getPayargsMonth = (sidLocal, grossPrice, actuallyPaid, thePayType, subject, sessionStorageLocal, code) => {
  return new Promise(function (resolve, reject) {
    const userAgent = common.getUserAgent()
    let path
    if (userAgent === 'wx') {
      path = 'pay.wx.do_h5_park_buy'
    }
    if (userAgent === 'zfb') {
      path = 'pay.zfb.do_h5_park_buy'
    }
    console.log('thePayType', thePayType)
    console.log('path', path)
    console.log(sessionStorageLocal, 'sessionStorageLocal')
    axios({
      url: chargeUrl + '/uuid/' + path,
      method: 'POST',
      data: {
        sid: sidLocal,
        gross_price: grossPrice,
        actually_paid: actuallyPaid,
        type: thePayType,
        subject: subject,
        business_info: sessionStorageLocal,
        code: code
      },
      header: {
        'content-type': 'application/json' // 默认值
      }
    }).then(res => {
      console.log(res, '' +
        '获取支付')
      const d = res && res.data
      console.log('获取支付d', d)
      if (d.code === 10000) {
        resolve(d.payargs)
      } else {
        console.log('getPayargsMonth-error', d.msg)
        reject(new Error(d.msg))
      }
    }).catch(e => {
      console.log('getPayargsMonth-catch', e)
      reject(e)
    })
  })
}
